// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2UQgl","header":"PatientBlock_header__Tdcf4","label":"PatientBlock_label__2FkMk","option":"PatientBlock_option__3tlXs"};